/**
 * Outbound marketplace links.
 *
 * Neither of these needs an API. That matters more than it used to: Countdown's
 * scraped eBay sold feed died in August 2026 because eBay now requires a
 * signed-in session for sold listings. These links open in the user's own
 * browser or eBay app, where they ARE signed in, so the sold filter works
 * exactly as before.
 */

const clean = (v) => (v == null ? '' : String(v).trim());

/**
 * eBay sold + completed search, pre-filtered.
 * Grade is included when the card is slabbed so the comps match the slab.
 */
export function ebaySoldUrl({ name, setName, number, variant, grade }) {
  const numPart = clean(number).split('/')[0];
  const finish = /reverse/i.test(clean(variant))
    ? 'reverse holo'
    : /holo/i.test(clean(variant))
      ? 'holo'
      : '';
  const terms = [clean(grade), clean(name), numPart, clean(setName), finish, 'pokemon']
    .filter(Boolean)
    .join(' ');
  return `https://www.ebay.com/sch/i.html?_nkw=${encodeURIComponent(terms)}&LH_Sold=1&LH_Complete=1`;
}

/**
 * TCGplayer. Prefer the direct product page when we know the product id -
 * a search box dumps the user on the wrong printing surprisingly often.
 */
export function tcgplayerUrl({ productId, name, setName, number }) {
  if (productId) return `https://www.tcgplayer.com/product/${productId}`;
  const numPart = clean(number).split('/')[0];
  const q = [clean(name), numPart, clean(setName)].filter(Boolean).join(' ');
  return `https://www.tcgplayer.com/search/pokemon/product?q=${encodeURIComponent(q)}`;
}
